import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

export const THEMES = [
  { id: "volt", label: "Volt", swatch: ["#4a6ee0", "#0c0f16"] },
  { id: "ember", label: "Ember", swatch: ["#f97a1f", "#161009"] },
  { id: "matrix", label: "Matrix", swatch: ["#16df4a", "#07120a"] },
  { id: "synth", label: "Synthwave", swatch: ["#f036a4", "#120c1c"] },
  { id: "arctic", label: "Arctic", swatch: ["#0c78c2", "#f4f7fa"] },
  { id: "paper", label: "Paper", swatch: ["#1a1a1a", "#ffffff"] },
  { id: "sakura", label: "Sakura", swatch: ["#e0447e", "#ffffff"] },
  { id: "mint", label: "Mint", swatch: ["#0e9f6e", "#ffffff"] },
  { id: "citrus", label: "Citrus", swatch: ["#e8590c", "#ffffff"] },
  { id: "lavender", label: "Lavender", swatch: ["#7048e8", "#ffffff"] },
];

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const { user } = useAuth();
  const [theme, setThemeState] = useState(() => localStorage.getItem("tj_theme") || "volt");

  useEffect(() => {
    if (user?.settings?.theme && !localStorage.getItem("tj_theme")) {
      setThemeState(user.settings.theme);
    }
  }, [user]);

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
  }, [theme]);

  const setTheme = (t) => {
    setThemeState(t);
    localStorage.setItem("tj_theme", t);
    if (user) api.put("/settings", { theme: t }).catch(() => {});
  };

  return <ThemeContext.Provider value={{ theme, setTheme }}>{children}</ThemeContext.Provider>;
}

export const useTheme = () => useContext(ThemeContext);
